import React from "react";
import { MsalProvider } from "@azure/msal-react";
import AuthWrapper from "./utils/auth/AuthWrapper";
import "./App.css";
function App({ msalInstance }) {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthWrapper />
    </MsalProvider>
  );
}

export default App;
